/** Actions redux qui ont un impact sur toutes les entités */

export const CHANGE_DATE = 'CHANGE_DATE';
export const CHANGE_SKIRESORT = 'CHANGE_SKIRESORT';

export function changeSkiresort(skiresort) {
  return {type: CHANGE_SKIRESORT, skiresort};
}


export function changeSelectedDate(date) {
  return {
    type: CHANGE_DATE,
    date
  };
}



// WEBPACK FOOTER //
// ./src/redux/global/actions.js